import { Observer } from 'mobx-react';
import { ModalPosition, openModal } from 'controls/react/ant/antModal';
import { Section } from 'controls/react/layout/section';
import { AntTextArea } from 'controls/react/ant/antInput';
import React from 'react';
import { translator } from 'core/localization';
import { observable } from 'mobx';
import { FormEntryNew } from 'controls/react/form/formEntryNew';

const i = translator({
	'Set information placeholder': {
		en: 'Add the text you want to be displayed in the information field. Note that this text will overwrite existing information, if present...',
		no: 'Legg til tekst du Ã¸nsker skal vises i informasjonsfeltet. Merk at det overskriver eksisterende informasjonstekst.',
	},
	'Set information': {
		no: 'Sett informasjon',
		en: 'Set information',
	},
});

export const opesSetInformationForm = (): [Promise<{ success: boolean; result: string }>, () => void] => {
	const model = observable({ information: '' });

	const { promise, close } = openModal(
		{
			okText: i('Update'),
			title: i('Set information'),
			resizable: false,
			positionType: ModalPosition.Mouse,
		},
		<Observer>
			{() => (
				<Section>
					<FormEntryNew model={model} modelField={'information'}>
						<AntTextArea placeholder={i('Set information placeholder')} height={100} />
					</FormEntryNew>
				</Section>
			)}
		</Observer>,
	);
	const result = new Promise<{ success: boolean; result: string }>((resolve) => {
		promise.then((result) => {
			resolve({ result: model.information, success: result ?? false });
		});
	});
	return [result, close];
};
